export const actionTypes = {
    SET_USER_SEARCH_HISTORY: 'SET_USER_SEARCH_HISTORY',
    SET_SEARCH_SCROLL_POSITION: 'SET_SEARCH_SCROLL_POSITION',
    SET_USER_FAVORITE_MENU: 'SET_USER_FAVORITE_MENU',
    SET_SHOW_LOG_IN_MODAL: 'SET_SHOW_LOG_IN_MODAL',
    SET_IS_LOG_IN: 'SET_IS_LOG_IN',
    SET_IS_SIDE_DRAWER_COLLAPSED: 'SET_IS_SIDE_DRAWER_COLLAPSED',
}
